export const FETCH_RANKS_REQUEST = 'FETCH_RANKS_REQUEST';
export const FETCH_RANKS_SUCCESS = 'FETCH_RANKS_SUCCESS';
export const FETCH_RANKS_FAILURE = 'FETCH_RANKS_FAILURE';
